import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { ITableColumn, ITableItem, TranslateService } from '@devinforius/super-compos-17';
import { ApiService } from 'src/app/core/services/api.service';
import { ITableConfig, SuperColumn } from '@devinforius/super-compos-17';
import { DataService } from 'src/app/core/services/data.service';
import { Global_Class } from 'src/app/shared/models/global';
import { Tabs } from '@devinforius/super-compos-17/lib/models/tabs';
import { Point } from 'src/app/shared/models/point';
import { MeetingPaginated } from 'src/app/shared/models/meeting';
import { getColumnsPoint, getColumnsMeeting } from './columns-config';
import { LazyLoadEvent } from 'primeng/api';
import { DetailSplit } from '@devinforius/super-compos-17/lib/i-scan-v3/models/detailsSplits';

@Component({
  selector: 'app-search-modal-scan',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.css'],
})
export class SearchModalScanComponent implements OnInit, OnChanges {
  modalHeader = {
    title: 'Modifier ce scan',
    iconTitle: 'bi bi-pen-fill',
    showNotification: false,
    showParameters: false,
    closable: true,
  };
  modalParams = {
    isDraggable: true,
    isResizable: true,
    isModal: true,
    style: { height: '80vh', width: '50vw', minWidth: '50vw', maxWidth: '50vw' },
  };
  dateSelected: Date = new Date();
  public columnsPoint: Array<ITableColumn>;
  public columnsMeeting: Array<ITableColumn>;
  public activeTab: number = 0;
  public tabs: Array<Tabs> = [
    { title: 'Point', active: this.activeTab === 0, slug: 'Point', icon: '' },
    { title: 'Séance', active: this.activeTab === 1, slug: 'Meeting', icon: '' },
  ];
  @Input() openEditDescription: boolean = false;
  @Input() infosCard: DetailSplit;
  @Input() guid: string;
  @Output() public closeModal: EventEmitter<ITableItem> = new EventEmitter();

  public dropdownValue: string = 'Titre';
  public dropdownLabel: string = 'Titre';
  public showOverlayDropdown: boolean = false;
  public onFocusInput: boolean = false;
  public pointSearch: string = '';
  public tableConfigurations: ITableConfig;
  public totalRecords: number = 0;
  public itemsPoint: ITableItem[] = [];
  public itemsMeeting: ITableItem[] = [];
  globalElements: Global_Class;
  public rows: number = 10;
  public first: number = 0;
  loadingPointTable: boolean = false;
  loadingMeetingTable: boolean = false;

  constructor(
    private toastr: ToastrService,
    public api: ApiService,
    private data: DataService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.columnsPoint = getColumnsPoint();
    this.data.getGlobalElements.subscribe((res: Global_Class) => {
      this.globalElements = new Global_Class(res);
      this.columnsMeeting = getColumnsMeeting(this.globalElements);
    });
    this.setConfigurationTable();
  }

  ngOnChanges(): void {
    if (this.openEditDescription && this.infosCard) {
      this.init();
    }
  }

  init(): void {
    if (this.infosCard?.title === 'Point' || this.infosCard?.title === 'Séance') {
      this.infosCard?.title === 'Point' ? (this.activeTab = 0) : (this.activeTab = 1);
      this.pointSearch = this.infosCard?.titleButton.toString();
      this.dropdownValue = 'Id';
      this.dropdownLabel = 'Id';
      this.searchPoint(this.infosCard?.title);
    } else {
      this.activeTab = 0;
      this.dropdownValue = 'Titre';
      this.dropdownLabel = 'Titre';
      this.searchPoint('Point');
    }
  }

  setConfigurationTable(): void {
    this.tableConfigurations = new ITableConfig({
      pageSize: this.rows,
      pageFirst: this.first,
      lazy: true,
      totalRecords: this.totalRecords,
      showPaginator: true,
      showColumnSelector: false,
      showForSelectionRow: false,
      isRowClickable: true,
      multiselect: false,
      viewSearch: false,
      resizableColumns: true,
      reorderableColumns: true,
      rowPerPageOptions: [10, 20, 50, 100, 500],
      height: '50vh',
      tableStyle: { width: '100%' },
    });
  }

  onClickDropdownInput(type: string): void {
    this.dropdownLabel = type;
    this.dropdownValue = type;
    this.showOverlayDropdown = false;
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  searchPoint(status: string, pageNumber?: number): void {
    if (status === 'Point') {
      this.loadingPointTable = true;
      const dataToSendToQuery = {
        RechercheGlobale: this.pointSearch,
        SortFields: 'id',
        SortOrder: 'DESC',
        pageSize: this.rows,
        pageNumber: pageNumber ? pageNumber : 1,
      };
      if (this.dropdownValue === 'Id' && !Number(this.pointSearch)) {
        this.toastr.error(`La valeur saisie n'est pas un nombre`);
        this.loadingPointTable = false;
        return;
      }
      this.dropdownValue === 'Id' ? (dataToSendToQuery.RechercheGlobale = `**${this.pointSearch}`) : null;
      this.api.getSearchPoint(dataToSendToQuery).subscribe(
        (res: any) => {
          this.itemsPoint = res.items;
          this.totalRecords = res.totalCount;
          this.setConfigurationTable();
          this.loadingPointTable = false;
        },
        () => {
          this.loadingPointTable = false;
          this.toastr.error(this.translate.translate('error.occurred'));
        }
      );
    } else if (status === 'Séance') {
      this.loadingMeetingTable = true;
      this.itemsMeeting = [];
      const dataToSendToQuery = {
        Date: this.formatDate(this.dateSelected),
        SortFields: 'description',
        SortOrder: 'DESC',
        countInclus: true,
        pageSize: this.rows,
        pageNumber: pageNumber ? pageNumber : 1,
      };

      this.api.getMeetingsSearch(dataToSendToQuery).subscribe(
        (res: MeetingPaginated) => {
          this.itemsMeeting = res.items as any as ITableItem[];
          this.totalRecords = res.totalCount;
          this.setConfigurationTable();
          this.loadingMeetingTable = false;
        },
        () => {
          this.loadingMeetingTable = false;
          this.toastr.error(this.translate.translate('error.occurred'));
        }
      );
    }
  }

  closeDialog(event?: ITableItem): void {
    this.openEditDescription = false;
    this.infosCard = null;
    this.dropdownLabel = null;
    this.dropdownValue = null;
    this.pointSearch = null;
    this.itemsPoint = [];
    this.itemsMeeting = [];
    this.closeModal.emit(event);
  }

  selectData(event: ITableItem): void {
    this.closeDialog(event);
  }

  onLazyLoad(event: LazyLoadEvent, type: string): void {
    this.rows = event.rows;
    const pageNumber = event.first / event.rows + 1;
    this.searchPoint(type, pageNumber);
  }

  tabChange(index: string): void {
    this.setConfigurationTable();
    if (index === 'Point') {
      this.activeTab = 0;
      this.searchPoint(index);
    }
    if (index === 'Meeting') {
      this.activeTab = 1;
      this.searchPoint('Séance');
    }
  }
}
